import { HeaderFooterStyle } from './../tenant/header-footer-style.enum';
var HelpcenterDesignBuilder = /** @class */ (function () {
    function HelpcenterDesignBuilder() {
        this.helpcenterDesign = {
            template: {
                key: 'bobkey'
            },
            colors: {
                color1: '#e2e2e2',
                color2: '#ffffff',
                headerFooterColor: HeaderFooterStyle.BRANDED
            },
            logo: {
                faviconUrl: 'http://favicon.com/image.png',
                imageUrl: 'http://logo.com/image.png',
                targetUrl: ''
            },
            images: {
                desktopBackgroundUrl: 'http://img.com/image.png',
                mobileBackgroundUrl: 'http://img.com/mobile.png',
                socialSharingUrl: 'http://img.com/mobile.png'
            }
        };
    }
    HelpcenterDesignBuilder.prototype.withTemplateKey = function (key) {
        this.helpcenterDesign.template.key = key;
        return this;
    };
    HelpcenterDesignBuilder.prototype.withColor1 = function (color) {
        this.helpcenterDesign.colors.color1 = color;
        return this;
    };
    HelpcenterDesignBuilder.prototype.withColor2 = function (color) {
        this.helpcenterDesign.colors.color2 = color;
        return this;
    };
    HelpcenterDesignBuilder.prototype.withHeaderFooterStyle = function (style) {
        this.helpcenterDesign.colors.headerFooterColor = style;
        return this;
    };
    HelpcenterDesignBuilder.prototype.withFaviconUrl = function (faviconUrl) {
        this.helpcenterDesign.logo.faviconUrl = faviconUrl;
        return this;
    };
    HelpcenterDesignBuilder.prototype.withLogoUrl = function (logoUrl) {
        this.helpcenterDesign.logo.imageUrl = logoUrl;
        return this;
    };
    HelpcenterDesignBuilder.prototype.withLogoTarget = function (targetUrl) {
        this.helpcenterDesign.logo.targetUrl = targetUrl;
        return this;
    };
    HelpcenterDesignBuilder.prototype.withDesktopBackgroundImage = function (desktopUrl) {
        this.helpcenterDesign.images.desktopBackgroundUrl = desktopUrl;
        return this;
    };
    HelpcenterDesignBuilder.prototype.withMobileBackgroundImage = function (mobileUrl) {
        this.helpcenterDesign.images.mobileBackgroundUrl = mobileUrl;
        return this;
    };
    HelpcenterDesignBuilder.prototype.build = function () {
        return this.helpcenterDesign;
    };
    return HelpcenterDesignBuilder;
}());
export { HelpcenterDesignBuilder };
//# sourceMappingURL=helpcenter-design.builder.js.map